export default __webpack_public_path__ + "static/media/dashboard.dcb0e6a8.webp";